import React, { Component } from 'react';
import { Container, LeftArea, RightArea } from './GalleryDialog.style';
import VideoArea from '../../SharedLinkPage/VideoArea/VideoArea';
import TitleArea from '../../SharedLinkPage/TitleArea/TitleArea';
import CommentArea from '../../SharedLinkPage/CommentArea/CommentArea';
import MoveTemplate from '../../SharedLinkPage/MoveTemplate/MoveTemplate';
import i18n from '../../i18n';
import ReportVideoPopup from '../../SharedLinkPage/ReportVideoPopup/ReportVideoPopup';
import ShareDialog from '../../UserPage/MyVideo/ShareDialog/ShareDialog';
import axios from 'axios';
import { GetBaseUrl } from '@/utils/ConfigHelper'
import OneBtnDialog from "../../Common/OneBtnDialog/OneBtnDialog";
import DesignSelectPopup from '../../DesignSelect/DesignSelectPopup/DesignSelectPopup';
import { connect } from 'react-redux';
import { _getTemplateById } from '../../Home';
import { Dialog } from "@material-ui/core";
import CommentReportDialog from '../CommentReportDialog/CommentReportDialog';
import TwoBtnDialog from '../../Common/TwoBtnDialog/TwoBtnDialog';
import { withStyles } from '@material-ui/core/styles';
import './GalleryDialog.scss';

import EditHashTagDialog from './EditHashTagDialog'
import FormatHelper from '../../utils/FormatHelper'

const styles = () => ({
    paper: {
        overflow: "unset"
    }
})

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

class GalleryDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            textValue: "",
            changeModityTextInput: "",
            reportValue: "a",
            commentReportValue: "a",
            isOpenReportPopup: false,
            isOpenShareDialog: false,
            isOpenEditHashtagDialog: false,
            isBtnDialogOpened: false,
            isOpenCommentReportPopup: false,
            dialogType: "shareSuccess",
            selectedVideo: {}, //공유시 템플릿 ,
            commentId: null,
            isOpenRemoveCommentTwoButton : false,
            isModify : false,
            galleryDialogSameTemplateVideos: [],
            hashtagString: ''
        }
        this.CommentAreaRef = undefined
    }

    needUpdateHashtagInput = false

    getTemplateById = async (videoId) => { return _getTemplateById(videoId) };
    
    changeCommentInput = (e) => { 
        this.setState({ textValue: e.target.value })
    }

    getNoWhiteSpacehashTags = () => {
        const { hashtagString } = this.state
        const { videoInfo } = this.props

        if(!videoInfo || !hashtagString) return ''

        let noWhiteSpaceHashTag = hashtagString
        if(noWhiteSpaceHashTag) noWhiteSpaceHashTag = noWhiteSpaceHashTag.replace(/ /gi, '')
        return noWhiteSpaceHashTag
    }

    // 공유 아이콘 클릭 함수
    share = (videoInfo) => {
        this.setState({ isOpenShareDialog: true, selectedVideo: videoInfo })
    }
    closeShareDialog = () => this.setState({ isOpenShareDialog: false })
    // 신고 아이콘 클릭 함수
    report = (id) => {
        const token = localStorage.getItem("token");
        if (!token) return this.props.loginRequest()
        this.setState({
            isOpenReportPopup: true,
        })
    }

    handleChangeEditHashTagDialog = input => {
        if (this.needUpdateHashtagInput) {
            this.needUpdateHashtagInput = false
            input = FormatHelper.convertToTagString(input)
        }
        else if (input.includes(' ')) {
            this.needUpdateHashtagInput = true
            input = FormatHelper.convertToTagString(input)
        }
        else if(input.includes('##')) {
            input = FormatHelper.convertToTagString(input)
        }
        else {
            input = FormatHelper.removeTagStringSpecialCharacters(input)
        }
        this.setState({ hashtagString: input })
    }
    
    handleCloseEditHashTagDialog = () => {
        this.setState({ isOpenEditHashtagDialog: false, hashtagString: '' })
    }

    handleConfirmEditHashTagDialog = async () => {
        let { hashtagString } = this.state

        if(!hashtagString) {
            hashtagString = this.getNoWhiteSpacehashTags()
        }
        else {
            hashtagString = FormatHelper.convertToTagString(hashtagString)
        }

        if(hashtagString.length === 1 && hashtagString[0] === '#') {
            hashtagString = ''
        }
        else if(hashtagString.length > 1 && hashtagString[hashtagString.length - 1] === '#') {
            hashtagString = hashtagString.substring(0, hashtagString.length - 1)
        }

        this.props.onUpdateHashTag(hashtagString)
        this.handleCloseEditHashTagDialog()
    }

    changeReportValue = (e) => {
        this.setState({
            reportValue: e.target.value
        })
    }
    changeCommentReportValue = (e) => {
        this.setState({
            commentReportValue: e.target.value
        })
    }
    changeModityTextInput = (e) => {
        this.setState({
            changeModityTextInput: e.target.value
        })
    }
    closeReportPopup = () => this.setState({ isOpenReportPopup: false , reportValue : "a"})
    closeCommentReportPopup = () => this.setState({ isOpenCommentReportPopup: false , commentReportValue : "a"})
    sendReport = async () => {
        const token = localStorage.getItem("token");
        const { _id, } = this.props.videoInfo
        const { reportValue } = this.state
        try {
            const result = await axios.post(`${GetBaseUrl()}/api/video/report`, { id: _id, value: reportValue }, { headers: { Authorization: `Bearer ${token}` } })
            if (result.data && result.data.message === "success") {
                this.closeReportPopup();
                this.setState({
                    dialogType: "reportSucces",
                    isBtnDialogOpened: true
                })
            } else if (result.data && result.data.message === "already") {
                this.closeReportPopup();
                this.setState({
                    dialogType: "reportAlready",
                    isBtnDialogOpened: true
                })
            }
            if (result && result.status === 404) {
                this.setState({
                    dialogType: "severError",
                    isBtnDialogOpened: true
                })
            }
        } catch (err) {
            this.setState({
                dialogType: "severError",
                isBtnDialogOpened: true
            })
        }
    }

    commentSendReport = async () => {
        const token = localStorage.getItem("token");
        const { _id } = this.props.videoInfo
        const { commentId, commentReportValue } = this.state
        try {
            const result = await axios.post(`${GetBaseUrl()}/api/video/report-comment`, { id: _id, commentid: commentId, value: commentReportValue }, { headers: { Authorization: `Bearer ${token}` } })
            if (result.data && result.data.message === "success") {
                this.closeCommentReportPopup();
                this.setState({
                    dialogType: "reportSucces",
                    isBtnDialogOpened: true
                })
            } else if (result.data && result.data.message === "already") {
                this.closeCommentReportPopup();
                this.setState({
                    dialogType: "reportAlready",
                    isBtnDialogOpened: true
                })
            }
            if (result && result.status === 404) {
                this.setState({
                    dialogType: "severError",
                    isBtnDialogOpened: true
                })
            }
        } catch (err) {
            this.setState({
                dialogType: "severError",
                isBtnDialogOpened: true
            })
        }
    }

    popupHandleCloseBtn = () => this.setState({ isBtnDialogOpened: false })

    lastPutTime = 0
    commentEnter = (videoId) => async (e) => {
        if (Date.now() - this.lastPutTime < 5000) return
        this.lastPutTime = Date.now()

        const { textValue } = this.state;
        const token = localStorage.getItem("token");
        if(!token) this.props.loginRequest()

        if(this.state.textValue.length === 0)return
        if (this.props.currentUser === undefined) { return this.props.loginRequest() }
        try {
            await axios.post(`${GetBaseUrl()}/api/video/put-comment`, { id: videoId, comment: textValue }, { headers: { Authorization: `Bearer ${token}` } });
            await this.props.updateVideoInfo(videoId)
            this.setState({ textValue: "" }, () =>this.CommentAreaRef.scrollTo({top: this.CommentAreaRef.scrollHeight, left : 0, behavior: 'smooth' }))
        }
        catch (err) {
            this.setState({ textValue: "" })
        }
    }
    openRemoveCommentDialog = (comment) => {
        this.setState({
            isOpenRemoveCommentTwoButton : true,
            commentId : comment.id,
            isModify : false
        })
    }
    handleCloseRemoveComment = () => {
        this.setState({
            isOpenRemoveCommentTwoButton : false,
            commentId : null
        })
    }
    commentRemove = async () => {
        const token = localStorage.getItem("token");
        const {commentId} = this.state
        const { _id } = this.props.videoInfo;
        if (!token) return this.props.loginRequest()

        try {
            await axios.post(`${GetBaseUrl()}/api/video/delete-comment`, { id: _id, commentid: commentId }, { headers: { Authorization: `Bearer ${token}` } })
            await this.props.updateVideoInfo(_id)
            this.setState({ dialogType: "commentRemove",isModify : false})
            this.handleCloseRemoveComment();
        }
        catch (err) {
            this.handleCloseRemoveComment();
        }
    }
    commentModify = (comment) => {
        this.setState({  commentId : comment.id , isModify : true , changeModityTextInput : comment.comment})
    }
    commentReport = (comment) => {
        const token = localStorage.getItem("token");
        if (!token) return this.props.loginRequest()

        this.setState({
            isOpenCommentReportPopup: true,
            commentId : comment.id
        })
    }
    commentCancel = () => {
        this.setState({
            commentId: null,
            isModify : false
        })
    }
    commentConfrim = async () => {
        const token = localStorage.getItem("token");
        if (!token) return this.props.loginRequest()
        
        const { _id } = this.props.videoInfo;
        const { commentId, changeModityTextInput } = this.state;
        if (changeModityTextInput.length === 0) { return this.setState({ commentId: null, changeModityTextInput: "" }) }
        if (!token) return this.props.loginRequest()

        try {
            await axios.post(`${GetBaseUrl()}/api/video/edit-comment`, { id: _id, commentid: commentId, comment: changeModityTextInput }, { headers: { Authorization: `Bearer ${token}` } })
            await this.props.updateVideoInfo(_id)
            this.setState({ commentId: null, changeModityTextInput: "" ,isModify : false})
        }
        catch (err) {
            this.setState({ commentId: null, changeModityTextInput: "" ,isModify : false})
        }
    }  

    closeDialog = () => {
        this.props.closeGalleryDialog();
        this.setState({ textValue: '', hashtagString: '' })
    }

    handleClickEditHashtagBtn = () => {
        const { videoInfo } = this.props

        this.setState({
            isOpenEditHashtagDialog: true, 
            hashtagString: videoInfo.hashtag ? videoInfo.hashtag : ''})
    }

    handleClickCommentUserNickname = (shareId, userId) => {
        if (!shareId) return
        const nxtPath = `/user-gallery/${shareId}`

        if (nxtPath === window.location.pathname) return
        this.props.history.push(nxtPath)
    }

    handleClickFollowBtn = async (userShareId, isUnfollow = false) => {
        if (!userShareId) return

        const token = localStorage.getItem("token");
        if (!token) return this.props.loginRequest()

        const { _id } = this.props.videoInfo;
        try {
            if (isUnfollow) {
                await axios.delete(`${GetBaseUrl()}/apis/follow/${userShareId}`, { headers: { Authorization: `Bearer ${token}` } })
                await this.props.updateVideoInfo(_id)
            }
            else {
                await axios.post(`${GetBaseUrl()}/apis/follow`, { userid: userShareId }, { headers: { Authorization: `Bearer ${token}` } })
                await this.props.updateVideoInfo(_id)
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    setCommentArea = (ref) => {
        this.CommentAreaRef = ref
    }
    setFocus = () => {
        
    }

    moveOriginanlTemplate = async () => {
        await this.props.moveOriginanlTemplate()
        
        for (let i=0; i<50; i++) {
            if (this.videoRef) {
                this.videoRef.pause()
                break
            }
            await sleep(100)
        }
    }

    render() {
        const { 
            textValue, 
            commentReportValue, 
            reportValue, 
            commentId,
            isModify,
            changeModityTextInput,
            isOpenEditHashtagDialog,
            hashtagString
        } = this.state
        const { 
            currentUser, 
            history, 
            open, 
            videoInfo, 
            isOriginalDesignDialogOpened, 
            originalTemplate, 
            getOriginalTemplateInfo, 
            heartClick,
            classes,
            onClickReturnBtn,
            onClickSameTemplate,
            onClickHashTag,
            onClickGoSeeMoreVideos,
            galleryDialogSameTemplateVideos,
            stackedVideoIds,
            blockUsers
        } = this.props

        if (!videoInfo) {
            return (
                <Dialog fullWidth={this.props.fullWidth} maxWidth={"md"} open={open}>
                    <Container>
                        <div className="closeBtn" onClick={this.closeDialog}>
                            <div className="closeBar1" />
                            <div className="closeBar2" />
                        </div>
                        <div style={{ margin: "auto", display: "flex", flexDirection: "column" }}>
                            <span className="share_empty-text">{i18n.t("mobile.share.error")}</span>
                        </div>
                    </Container>
                </Dialog>
            )
        }

        const isMine = (currentUser) ? videoInfo.id === currentUser._id : false
        const viewCount = FormatHelper.convertToKMB(videoInfo.viewCount)
        const templateInfos = galleryDialogSameTemplateVideos || []

        const hashTags = videoInfo.hashtag ? videoInfo.hashtag.split(' ') : []
        const noWhiteSpaceHashTag = this.getNoWhiteSpacehashTags()
        const filteredComment = videoInfo.comments.filter(item => !blockUsers[item.userid])

        return (
            <Dialog 
                fullWidth={this.props.fullWidth}
                maxWidth={false}
                open={open} 
                onClose={this.closeDialog}
            >
                <div className="gallery-dialog-main-container">
                    <Container>
                        <LeftArea>
                            <VideoArea
                                src={videoInfo.url}
                                controls
                                autoPlay
                                videoRef={ref => this.videoRef = ref}
                                muted={false}
                                loop={false}
                                poster={videoInfo && videoInfo.template && videoInfo.template.thumnailURL}
                            />
                        </LeftArea>
                        <RightArea>
                            <TitleArea
                                {...this.props}
                                title={videoInfo.name}
                                heartCount={videoInfo.likeMembers}
                                commentCount={filteredComment ? filteredComment.length : 0}
                                isHeartClicked={videoInfo.isLike}
                                nickname={videoInfo.username}
                                id={videoInfo.id}
                                isMine={isMine}
                                hashTags={hashTags}
                                viewCount={viewCount}
                                shareId={videoInfo.userShareId}
                                isFollowing={videoInfo.isFollowed}
                                isStaffPick={videoInfo.isStaffPick}
                                isHotVideo={videoInfo.isStaffPick}      // hot 100 판별 변수, 추후 수정 필요
                                onClickFollowBtn={this.handleClickFollowBtn}
                                onClickHashTag={onClickHashTag}
                                onClickEditHashtag={this.handleClickEditHashtagBtn}
                                onHeartClick={(e) => heartClick(videoInfo._id, e)}
                                onShare={() => this.share(videoInfo)}
                                onReport={() => this.report(videoInfo)}
                            />
                            <CommentArea
                                isModify={isModify}
                                commentList={filteredComment}
                                currentUser={currentUser}
                                notSharedText={i18n.t("web.shared.not.share.text")}
                                onRemove={this.openRemoveCommentDialog}
                                onModify={this.commentModify}
                                onReport={this.commentReport}
                                onCommentCancel={this.commentCancel}
                                onCommnetConfrim={this.commentConfrim}
                                changeModityTextInput={this.changeModityTextInput}
                                selectedComment={commentId}
                                setCommentArea={this.setCommentArea}
                                modifyComment={changeModityTextInput}
                                onClickNickname={this.handleClickCommentUserNickname}

                                textValue={textValue}
                                setFocus={this.setFocus}
                                onInputChange={this.changeCommentInput}
                                onInputClick={this.commentEnter(videoInfo._id)}
                            />
                        </RightArea>

                        <ReportVideoPopup
                            reportValue={reportValue}
                            onChange={this.changeReportValue}
                            open={this.state.isOpenReportPopup}
                            onClose={this.closeReportPopup}
                            sendReport={this.sendReport}
                        />
                        <ShareDialog
                            open={this.state.isOpenShareDialog}
                            onClose={this.closeShareDialog}
                            onShare={this.props.clickShareItem}
                        />
                        <OneBtnDialog
                            dialogType={this.state.dialogType}
                            open={this.state.isBtnDialogOpened}
                            closeBtn={this.popupHandleCloseBtn}
                            onButtonClick={this.popupHandleCloseBtn}
                        />
                        <CommentReportDialog
                            reportValue={commentReportValue}
                            onChange={this.changeCommentReportValue}
                            open={this.state.isOpenCommentReportPopup}
                            onClose={this.closeCommentReportPopup}
                            sendReport={this.commentSendReport}
                        />
                        <TwoBtnDialog
                            open={this.state.isOpenRemoveCommentTwoButton}
                            onClose={this.handleCloseRemoveComment}
                            onClick={this.commentRemove}>
                            <div>{i18n.t("web.shared.delete.comment")}</div>
                        </TwoBtnDialog>
                        {
                            getOriginalTemplateInfo &&
                            <DesignSelectPopup
                                isDialogOpened={isOriginalDesignDialogOpened}
                                selectedVideo={originalTemplate}
                                templateGroupMap={this.props.templateGroupMap}
                                onVideoLikedButtonClicked={this.props.onVideoLikedButtonClicked}
                                history={history}
                                changeSelectedVideo={this.props.updateSelectedTemplate}
                                closeDialog={this.props.closeOrigianlDialog}
                            />
                        }
                        <EditHashTagDialog
                            open={isOpenEditHashtagDialog}
                            hashtags={noWhiteSpaceHashTag}
                            onChange={this.handleChangeEditHashTagDialog}
                            onClose={this.handleCloseEditHashTagDialog}
                            onConfirm={this.handleConfirmEditHashTagDialog}
                        />
                    </Container>

                    <div className="gallery-dialog-bottom-area">
                        {
                            (templateInfos && templateInfos.length > 0)
                            &&
                            <>
                                <div className="gallery-dialog-label-container">
                                    <div>{i18n.t("web.gallery.dialog.other.videos")}</div>
                                    <div onClick={() => { onClickGoSeeMoreVideos(videoInfo.template._id) }}>{i18n.t("web.gallery.dialog.other.videos.show") + " >"}</div>
                                </div>

                                <div className="gallery-dialog-template-container scroll-x">
                                    {
                                        (templateInfos && templateInfos.length > 0)
                                        &&
                                        templateInfos.map(info => {
                                            return (
                                                <div className="gallery-dialog-template-item" onClick={() => { onClickSameTemplate(info._id) }}>
                                                    <div className="img-container">
                                                        <img src={info.thumbnailURL} alt="icon-template-thumbnail" />
                                                    </div>
                                                    <div className="profile-container">
                                                        <img src={info.profileURL ? info.profileURL : "https://front.videomonster.com/images-u6yd72dy/common/v2-profile.svg"} alt="icon-profile" />
                                                        <div>{info.username}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                {
                                    (stackedVideoIds && stackedVideoIds.length > 0)
                                    &&
                                    <button className="gallery-dialog-return-btn" onClick={onClickReturnBtn}>
                                        {i18n.t("web.video.return.btn.label")}
                                    </button>
                                }
                            </>
                        }

                        <div className="gallery-dialog-bottom-btn-container">
                            <button className="gallery-dialog-close-btn" onClick={this.closeDialog}>
                                {i18n.t("global.close")}
                            </button>
                            <MoveTemplate
                                text={i18n.t("web.shared.move.original.template")}
                                onMoveOriginalTemplate={this.moveOriginanlTemplate}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}


const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    value: state.langStore.lang,
    blockUsers: state.blockUserStore.blockUsers
})


export default connect(mapStateToProps, null)(withStyles(styles)(GalleryDialog))